<div class="card mb-5">
  <div class="card-body">
    <h2 class="mt-3">
      <h2 class="mt-3">{{ 'consultantreport.title' | translate }}</h2>
    </h2>
    <hr />
    <cfp-loading-spinner
      [loading]="isLoading() || isLoadingEditor()"
      [error]="!!errorMessage()"
      [errorMessage]="errorMessage()"
    />
    @if (form(); as form) {
      @if (!isLoading() && !isLoadingEditor()) {
        <form (submit)="ngForm.valid && save()" [formGroup]="form" #ngForm="ngForm">
          <!-- Date scan -->
          <div class="row mb-2">
            <div class="col-sm-3">
              <h5>{{ 'consultantreport.scandate' | translate }}</h5>
            </div>
            <div class="col-sm-3">
              <cfp-input-datepicker formControlName="checkDate" />
              @if (ngForm.submitted && showValidation('checkDate', 'required')) {
                <div class="validation-feedback text-danger mt-2">
                  <i class="fa fa-exclamation"></i>
                  {{ 'validation.required' | translate: { name: ('consultantreport.scandate' | translate) } }}
                </div>
              }
            </div>
          </div>
          <!-- /Date scan -->
          <!-- Description consultant -->
          <div class="row mb-2">
            <div class="col-sm-3">
              <h5>{{ 'description.consultant' | translate }}</h5>
            </div>
            <div class="col-sm-9">
              @if (editor() && useHtmlEditor) {
                <ckeditor
                  [editor]="editor()"
                  [config]="editorConfig"
                  (change)="onEditorChange($event)"
                  (ready)="onEditorReady($event)"
                />
              }
              @if (!useHtmlEditor) {
                <textarea
                  class="form-control"
                  rows="5"
                  formControlName="description"
                  [maxLength]="buildingReportDescriptionMaxLength"
                ></textarea>
              }
              @if (ngForm.submitted && showValidation('description', 'maxlength')) {
                <div class="validation-feedback text-danger mt-2">
                  <i class="fa fa-exclamation"></i>
                  {{ 'validation.maxlength' | translate: { requiredLength: buildingReportDescriptionMaxLength } }}
                </div>
              }
            </div>
          </div>
          <!-- /Description consultant -->
          <!-- Show CFP logo -->
          @if (environment.components.consultantReportCanEditShowCfpLogo) {
            <div class="row mb-2">
              <label class="col-form-label col-12 col-sm-3">{{ 'consultantreport.showCfpLogo' | translate }}</label>
              <div class="col-sm-3">
                <select class="form-control" formControlName="showCfpLogo">
                  <option [ngValue]="false">{{ 'no' | translate }}</option>
                  <option [ngValue]="true">{{ 'yes' | translate }}</option>
                </select>
              </div>
            </div>
          }
          <!-- /Show CFP logo -->
          <!-- Show partnership logo -->
          @if (environment.images.consultantReportPartnershipLogo) {
            <div class="row mb-2">
              <label class="col-form-label col-12 col-sm-3">{{
                'consultantreport.showPartnershipLogo' | translate
              }}</label>
              <div class="col-sm-3">
                <select class="form-control" formControlName="showEnergeticRegionLogo">
                  <option [ngValue]="false">{{ 'no' | translate }}</option>
                  <option [ngValue]="true">{{ 'yes' | translate }}</option>
                </select>
              </div>
            </div>
          }
          <!-- /Show partnership logo -->
          <!-- User partnership logo -->
          @if (environment.components.consultantReportCanUploadUserPartnershipLogo) {
            <div class="row mb-2 align-items-center">
              <label class="col-form-label col-12 col-sm-3">{{
                'consultantreport.userPartnershipLogo' | translate
              }}</label>
              @if (partnershipLogoAsBase64(); as partnershipLogoAsBase64) {
                <div class="col-auto">
                  <!-- Current Image-->
                  <img class="partnership-logo" [src]="partnershipLogoAsBase64" />
                  <!-- /Current Image -->
                </div>
                <div class="col-auto">
                  <small class="text-muted cursor-pointer" (click)="userPartnershipLogoDeleted()">{{
                    'remove.button' | translate
                  }}</small>
                </div>
              }
              <div class="col-auto">
                <cfp-image-upload-button
                  [buttonText]="buildingReport()?.hasPartnershipLogo ? 'change.button' : 'add.button'"
                  [btnClass]="'btn-outline-primary'"
                  (imageSelected)="userPartnershipLogoSelected($event)"
                  class="d-flex"
                />
              </div>
            </div>
          }
          <!--/ User partnership logo -->
          <div class="row mb-2">
            <div class="offset-sm-3 col-sm-9 text-end">
              @if (showDeleteButton && buildingReport()?.consultant) {
                <button type="button" class="btn btn-outline-primary me-2" (click)="delete()">
                  {{ 'delete.button' | translate }}
                </button>
              }
              <button type="submit" class="btn btn-primary">{{ 'save.button' | translate }}</button>
            </div>
          </div>
        </form>
      }
    }
  </div>
</div>
